import { Vue, Component } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { Form } from 'element-ui';
import { ILOGPRE } from '@/types/base.d';
import { ICharge } from '@/types/org.d';
import api from '@/api/org';

@Component
export default class formMixin extends Vue {
  @State(state => state.org.curComp) curComp!: string;

  @Mutation('org/SET_ORG_BTN_COMPENT') setCurComp!: Function;

  @Mutation('org/SET_ORG_INFO_STATUS') handleRefreshInfo!: Function;

  @Mutation('org/SET_ORG_RECHARGE_STATUS') handleRefreshRecharge!: Function;

  @Mutation('org/SET_ORG_COMPENT_REFRESH') handleRerfesh!: Function;

  public log: ILOGPRE = {
    name: '机构管理 - 充值 - 模态框 -',
    component: 'org/manage/components/bModal',
  };

  public form: ICharge = {
    money: 500,
    payType: 0,
    remark: '',
    orgPid: '',
  };

  private loading: boolean = false;

  private moneyVali = (rule: any, value: any, callback: Function) => {
    if (value < 0) callback(new Error('金额不能为负'));
    if (value === 0) callback(new Error('金额不能为零'));
    else callback();
  }

  public $refs!: {
    form: Form,
  };

  private payTypes: { label: string, value: number }[] = [
    { label: '待定', value: 0 },
    { label: '支付宝', value: 1 },
    { label: '微信', value: 2 },
    { label: '对公账户', value: 3 },
    { label: '赠送', value: 4 },
  ];

  private rules: any = {
    money: [
      { required: true, message: '金额不能为空' },
      { validator: this.moneyVali, trigger: 'blur' },
    ],
    payType: [
      { required: true, message: '充值类型不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }

  /**
   * @author Terry
   * @description 提交Form 完成后执行此方法
   */
  submitFinish(edit: boolean = false) {
    this.reset(true, true);
    this.loading = false;
    if (!edit) {
      this.handleRefreshInfo(true);
      this.handleRefreshRecharge(true);
    }
    if (this.curComp !== 'Account') this.setCurComp('Account');
    this.handleRerfesh(true);
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑充值/对充
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        if (title.includes('编辑充值')) {
          const data = Object.assign({}, this.form);
          delete data.orgPid;
          delete data.money;
          api.editCharge(this.form).then(() => {
            this.submitFinish(true);
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else if (title === '对充') {
          const data = this.form;
          delete data.payType;
          api.addContra(data).then(() => {
            this.submitFinish();
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else if (title === '充值') {
          api.addCharge(this.form).then(() => {
            this.submitFinish();
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else if (title === '编辑对充') {
          const data = Object.assign({}, this.form);
          delete data.payType;
          delete data.orgPid;
          delete data.money;
          api.editContra(data).then(() => {
            this.submitFinish(true);
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }
}
